import React from 'react'
import { useHistory } from 'react-router-dom'
import { IonIcon } from '@ionic/react'
import { alertCircleOutline, cartOutline } from 'ionicons/icons'
import './index.scss'
import { formatCurrency } from '../../../../utils/intl'

interface Props {
  reason: 'minimum' | 'stock' | 'both'
  providersWithMinimumIssue?: Array<{
    name: string
    currentTotal: number
    minimum: number
    providerId: string
  }>
  stockAdjustmentMessage?: string
}

function CartAlert({ reason, providersWithMinimumIssue = [], stockAdjustmentMessage }: Props) {
  const history = useHistory()

  const getTitle = () => {
    if (reason === 'stock') return ' Stock actualizado'
    if (reason === 'minimum') return ' Mínimo de compra no alcanzado'
    return ' No puedes completar tu pedido'
  }

  const getMessage = () => {
    if (reason === 'stock') {
      return stockAdjustmentMessage || 'Algunos productos tuvieron cambios en su disponibilidad.'
    }
    
    if (reason === 'minimum') {
      return 'No alcanzas el mínimo de compra requerido por uno o más proveedores.'
    }

    return 'Hay productos con stock actualizado y no alcanzas el mínimo de compra requerido.'
  }

  const redirectToProvider = (providerId: string) => {
    history.push(`/home-providers/${providerId}`)
  }

  return (
    <div className="cart-alert">
      <div className="cart-alert__header">
        <IonIcon icon={alertCircleOutline} className="cart-alert__icon" />
        <h4>{getTitle()}</h4>
      </div>

      <div className="cart-alert__content">
        <p className="cart-alert__message">{getMessage()}</p>

        {(reason === 'minimum' || reason === 'both') && providersWithMinimumIssue.length > 0 && (
          <div className="cart-alert__providers">
            <p className="cart-alert__subtitle">Proveedores con mínimo no alcanzado:</p>
            {providersWithMinimumIssue.map((provider) => (
              <div key={provider.providerId} className="cart-alert__provider-item">
                <div className="cart-alert__provider-info">
                  <strong>{provider.name}</strong>
                  <span>
                    Tienes: {formatCurrency(provider.currentTotal)} / Mínimo: {formatCurrency(provider.minimum)}
                  </span>
                </div>
                <button
                  className="cart-alert__button cart-alert__button--secondary"
                  onClick={() => redirectToProvider(provider.providerId)}
                >
                  Agregar productos
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="cart-alert__actions">
          <button
            className="cart-alert__button cart-alert__button--primary"
            onClick={() => history.push('/home')}
          >
            <IonIcon icon={cartOutline} />
            Ir al catálogo
          </button>
        </div>
      </div>
    </div>
  )
}

export default CartAlert
